import Entity from '@/models/entities/Entity';

export class ProductCategoryOption implements Entity {
  public id: number = 0;
  public title: string = '';
  public value: boolean = false;
  public pricePerPair: number | null = null;
  public overrideInProduct: boolean = false;
  public minQuantity: number | null = null;
  public minSizeQuantity: number | null = null;
  public hasOverriddenValue: boolean = false;
  public keyWord?: string;

  constructor(initData: Partial<ProductCategoryOption>) {
    Object.assign(this, initData);
  }
}
